// extracted by mini-css-extract-plugin
export default {"blockContainer":"block-container-module--block-container--37c6e"};